module.exports = __webpack_public_path__ + "static/img/SketchPngddefe8e6d3ac9485bb71da77530b8ebd822ead9b438437c5c146a90e5edfb765.fb645db5.png";